window.addEventListener("DOMContentLoaded", () => {
    let IS_LOADING = false;
    let scrollableElement = $('div[data-jobs-scroll]')

    // fetchJobsDetails(loadJobsRoute)

    $(document).on('click', 'a[data-job-card-title]', (e) => {
        e.preventDefault()
    })

    $('button[data-search]').on('click', (e) => {
        e.preventDefault()

        $('div[data-all-jobs-container]').html('')
        fetchJobsDetails(loadJobsRoute)
    })

    scrollableElement.on('scroll', (e) => {
        let url = '';

        if (IS_LOADING) {
            return;
        }

        if($(e.currentTarget).scrollTop() + $(e.currentTarget).innerHeight() <= $(e.currentTarget)[0].scrollHeight) {
            IS_LOADING = true;
            url = $(e.currentTarget).data('url');
        }

        if (url !== '') {
            fetchJobsDetails(url);
        }
    })

    $(document).on('click', 'div[data-job-card]', (e) => {
        let jobId = $(e.currentTarget).data('job')
        let jobsDetailsContainer = $('div[data-job-details-container]')
        let JobsStudentApplyContainer = $('div[data-job-apply-container]')
        let allJobsParam = new URL(window.location.href).searchParams.get('previous') ?? '';

        axios.post(fetchJobDetailsRoute, {jobId, allJobsParam})
            .then(({data : {jobDetailsView, rewrite_url,jobStudentView}}) => {
                jobsDetailsContainer.html('').append(jobDetailsView).show()
                JobsStudentApplyContainer.html('').append(jobStudentView).hide()
                ChangeUrl(rewrite_url, `${rewriteUrlRoute}/${rewrite_url}`)
            })
            .catch(({response}) => {
                Swal.fire({
                    icon: "error",
                    text: response.data.message,
                });
            })
    })


    $('select[data-work-time-select]').on('change', (e) => {
        $('div[data-all-jobs-container]').html('')
        fetchJobsDetails(loadJobsRoute)
        $(e.currentTarget).parents('.custom-career-select').find('[data-remove-filter]').removeClass('d-none')
        if (checkFilterForm() !== 0) {
            $('span[data-filter-text]').removeClass('d-none')
        } else {
            $('span[data-filter-text]').addClass('d-none')
        }
    })

    $('select[data-skill-set-select]').on('change', (e) => {
        $('div[data-all-jobs-container]').html('')
        fetchJobsDetails(loadJobsRoute)
        $(e.currentTarget).parents('.custom-career-select').find('[data-remove-filter]').removeClass('d-none')
        if (checkFilterForm() !== 0) {
            $('span[data-filter-text]').removeClass('d-none')
        } else {
            $('span[data-filter-text]').addClass('d-none')
        }
    })

    $('select[data-requirements-select]').on('change', (e) => {
        $('div[data-all-jobs-container]').html('')
        fetchJobsDetails(loadJobsRoute)
        $(e.currentTarget).parents('.custom-career-select').find('[data-remove-filter]').removeClass('d-none')
        if (checkFilterForm() !== 0) {
            $('span[data-filter-text]').removeClass('d-none')
        } else {
            $('span[data-filter-text]').addClass('d-none')
        }
    })

    $('select[data-posted-at-select]').on('change', (e) => {
        $('div[data-all-jobs-container]').html('')
        fetchJobsDetails(loadJobsRoute)
        $(e.currentTarget).parents('.custom-career-select').find('[data-remove-filter]').removeClass('d-none')
        if (checkFilterForm() !== 0) {
            $('span[data-filter-text]').removeClass('d-none')
        } else {
            $('span[data-filter-text]').addClass('d-none')
        }
    })

    $('select[data-location-select]').on('change', (e) => {
        $('div[data-all-jobs-container]').html('')
        fetchJobsDetails(loadJobsRoute)
        $(e.currentTarget).parents('.custom-career-select').find('[data-remove-filter]').removeClass('d-none')
        if (checkFilterForm() !== 0) {
            $('span[data-filter-text]').removeClass('d-none')
        } else {
            $('span[data-filter-text]').addClass('d-none')
        }
    })

    $(document).on('input', '[data-job-name-input]', $.debounce(250, (e) => {
        $('div[data-all-jobs-container]').html('')
        fetchJobsDetails(loadJobsRoute)
        if (checkFilterForm() !== 0) {
            $('span[data-filter-text]').removeClass('d-none')
        } else {
            $('span[data-filter-text]').addClass('d-none')
        }
    }))

    $('[data-remove-filter]').on('click', (e) => {
        let selectorName = $(e.currentTarget).data('name')

        $(`select[name="${selectorName}"]`).val('').trigger('change')
        $(e.currentTarget).addClass('d-none')

        if (checkFilterForm() === 0) {
            $('span[data-filter-text]').addClass('d-none')
        }
    })

    function fetchJobsDetails(url)
    {
        let jobsContainer = $('div[data-all-jobs-container]')

        let data = new FormData()

        for (const [, { name, value }] of Object.entries($('form[data-select-form]').serializeArray())) {
            data.append(name, value)
        }

        axios.post(url, data)
            .then(({data : {jobsView, jobs, jobsCount}}) => {
                jobsContainer.append(jobsView)
                IS_LOADING = false

                scrollableElement.data('url', jobs.next_page_url || '')
                $('span[data-jobs-count]').html(jobsCount)
            })
            .catch(({response}) => {
                Swal.fire({
                    icon: "error",
                    text: response.data.message,
                });
            })
    }

    function ChangeUrl(page, url) {
        if (typeof (history.pushState) != "undefined") {
            let obj = { Page: page, Url: url };
            history.pushState(obj, obj.Page, obj.Url);
        } else {
            alert("Browser does not support HTML5.");
        }
    }

    function checkFilterForm() {
        return $('form[data-select-form] [name]').filter(function () {
            return $(this).val().length !== 0;
        }).length
    }
})


$(document).on('click', '.apply-browsing', function(e) {
        const coverLetter = $('#messageApply').val();
        const jobId = $(this).data('job');

        axios.post(jobApplicationRoute, {
            cover_letter: coverLetter,
            job_id: jobId
        })
            .then(response => {
                Swal.fire('Success', response.data.message, 'success')
                $(this).prop('disabled', true)
                $('#messageApply').prop('disabled', true);
                $('.apply-btn[data-job-apply]').prop('disabled', true)
                $('.replace-test').text('Already applied')
                $('.replace-apply').text('Applied')
                setTimeout(function () {
                    $('.back-browsing').trigger('click');
                },1000)


            })
            .catch(({response}) => {
                Swal.fire('Oops..', response.data.message, 'error')
            })
    });

$(document).on('click', '.apply-btn[data-job-apply]', function () {
    $('.full-job-desc[data-job-details-container]').hide();
    $('.full-job-desc[data-job-apply-container]').show();
});

$(document).on('click', '.back-browsing', function () {
    $('.full-job-desc[data-job-details-container]').show();
    $('.full-job-desc[data-job-apply-container]').hide();
});